export const QS_QUERY_KEY = "q";
export const QS_SOURCE_KEY = "source";
export const HEADER_SOURCE = "header";
